<template>
    <Background
        :backPath="'prevPage'">
        <div class="info-area">
            <div class="title">
                商户信息
            </div>
            <div class="info-paragraph">
                <div class="info-line">
                    <div class="info-label">老板名字</div>
                    <div class="content-area">
                        <div class="info-content">{{ userName }}</div>
                        <a-icon
                            v-on:click="popEditDialog('bossName')"
                            class="edit-button"
                            type="highlight"
                        />
                    </div>
                </div>
                <div class="info-line">
                    <div class="info-label">老板电话</div>
                    <div class="content-area">
                        <div class="info-content">{{ phone }}</div>
                        <a-icon
                            v-on:click="popEditDialog('bossPhone')"
                            class="edit-button"
                            type="highlight" />
                    </div>
                </div>
                <div class="info-line">
                    <div class="info-label">邮箱</div>
                    <div class="info-content">{{ email }}</div>
                </div>
                <div class="info-line">
                    <div class="info-label">老板ID</div>
                    <div class="info-content">{{ userId }}</div>
                </div>
            </div>
            <div class="info-paragraph">
                <div class="info-line">
                    <div class="info-label">企业全称</div>
                    <div class="content-area">
                        <div class="info-content">{{ companyName }}</div>
                        <a-icon
                            v-on:click="popEditDialog('companyName')"
                            class="edit-button"
                            type="highlight" />
                    </div>
                </div>
                <div class="info-line">
                    <div class="info-label">商户简称</div>
                    <div class="content-area">
                        <div class="info-content">{{ shopName }}</div>
                        <a-icon
                            v-on:click="popEditDialog('shopName')"
                            class="edit-button"
                            type="highlight" />
                    </div>
                </div>
                <div class="info-line">
                    <div class="info-label">商户号</div>
                    <div class="info-content">{{ shopId }}</div>
                </div>
                <div class="info-line"/>
            </div>

            <div class="info-paragraph">
                <div class="info-line">
                    <div class="info-label">微信商户号</div>
                    <div class="content-area">
                        <div class="info-content">{{ wxMchId }}</div>
                        <a-icon
                            v-on:click="popEditDialog('wxMchId')"
                            class="edit-button"
                            type="highlight" />
                    </div>
                </div>
                <div class="info-line">
                    <div class="info-label">微信支付模板号</div>
                    <div class="content-area">
                        <div class="info-content">{{ wxPlanId }}</div>
                        <a-icon
                            v-on:click="popEditDialog('wxPlanId')"
                            class="edit-button"
                            type="highlight" />
                    </div>
                </div>
            </div>
            <div class="info-paragraph">
                <div class="info-line">
                    <div class="info-label">商品库容量</div>
                    <div class="content-area">
                        <div class="info-content">{{ commodityLimit }}</div>
                        <a-icon
                            v-on:click="popEditDialog('commodityLimit')"
                            class="edit-button"
                            type="highlight" />
                    </div>
                </div>
                <div class="info-line">
                    <div class="info-label">货柜容量</div>
                    <div class="content-area">
                        <div class="info-content">{{ machineCommodityLimit }}</div>
                        <a-icon
                            v-on:click="popEditDialog('machineCommodityLimit')"
                            class="edit-button"
                            type="highlight" />
                    </div>
                </div>
            </div>
            <div class="info-paragraph">
                <div class="info-line">
                    <div class="info-label">创建时间</div>
                    <div class="info-content">{{ createdAt }}</div>
                </div>
            </div>

            <a-button
                v-on:click="deleteUser"
                class="delete-button"
                size="large"
                type="danger">
                删除商户
            </a-button>
        </div>

        <MerchantEditDialog
            ref="dialog"
            :title="editInfoTitle"
            :hint="editInfoHint"
            :type="editInfoType"
            :successMessage="editInfoSuccessMessage"
            :userId="editInfoUserId"
            :updateInfoCallback="updateInfo"
        />
    </Background>
</template>

<script>
 import Vue from 'vue';

 import Background from "./Background.vue"
 import MerchantEditDialog from "./MerchantEditDialog.vue"
 import Modal from "ant-design-vue/lib/modal";

 import { parseDate } from "../util/date.js"

 import message from "ant-design-vue/lib/message";

 Vue.component(Modal.name, Modal);

 export default {
     name: 'MerchantInfo',
     data() {
         return {
             userId: "",
             userName: "",
             phone: "",
             email: "",
             shopId: "",
             shopName: "",
             companyName: "",
             wxMchId: "",
             wxPlanId: "",
             createdAt: "",
             commodityLimit: 0,
             machineCommodityLimit: 0,

             editInfoTitle: "",
             editInfoHint: "",
             editInfoType: "",
             editInfoSuccessMessage: "",
             editInfoUserId: 0
         }
     },
     props: {
     },
     components: {
         Background,
         MerchantEditDialog
     },
     computed: {
     },
     mounted() {
         var info = JSON.parse(sessionStorage.getItem("clickMerchantInfo"))
         this.userId = info.UserId
         this.userName = info.Username
         this.phone = info.Phone
         this.shopId = info.Shop.ShopId
         this.shopName = info.Shop.ShopName
         this.wxMchId = info.Shop.WxMchId
         this.wxPlanId = info.Shop.WxPlanId
         this.commodityLimit = info.Shop.CommodityLimit
         this.machineCommodityLimit = info.Shop.MachineCommodityLimit
         this.createdAt = parseDate(info.Shop.CreatedAt)

         if (info.Email == "") {
             this.email = "用户未设置"
         } else {
             this.email = info.Email
         }
         if (info.Shop.CompanyName == "") {
             this.companyName = "未填写"
         } else {
             this.companyName = info.Shop.CompanyName
         }
     },
     methods: {
         popEditDialog(type) {
             if (type == "bossName") {
                 this.editInfoTitle = "编辑老板名字",
                 this.editInfoHint = "请输入老板名字"
                 this.editInfoSuccessMessage = "老板名字更新成功"
             } else if (type == "bossPhone") {
                 this.editInfoTitle = "编辑老板电话",
                 this.editInfoHint = "请输入老板电话"
                 this.editInfoSuccessMessage = "老板电话更新成功"
             } else if (type == "companyName") {
                 this.editInfoTitle = "编辑企业全称",
                 this.editInfoHint = "请从微信子商户拷贝企业全称"
                 this.editInfoSuccessMessage = "企业全称更新成功"
             } else if (type == "shopName") {
                 this.editInfoTitle = "编辑商户简称",
                 this.editInfoHint = "请从微信子商户拷贝微信商户简称"
                 this.editInfoSuccessMessage = "商户简称更新成功"
             } else if (type == "wxMchId") {
                 this.editInfoTitle = "编辑商户号",
                 this.editInfoHint = "请从微信子商户拷贝微信商户号"
                 this.editInfoSuccessMessage = "微信商户号更新成功"
             } else if (type == "wxPlanId") {
                 this.editInfoTitle = "编辑支付模板号",
                 this.editInfoHint = "请从微信子商户拷贝微信支付模板号"
                 this.editInfoSuccessMessage = "微信支付模板号更新成功"
             } else if (type == "commodityLimit") {
                 this.editInfoTitle = "编辑商品库容量",
                 this.editInfoHint = "请输入商品库容量"
                 this.editInfoSuccessMessage = "商品库容量更新成功"
             } else if (type == "machineCommodityLimit") {
                 this.editInfoTitle = "编辑货柜容量",
                 this.editInfoHint = "请输入货柜容量"
                 this.editInfoSuccessMessage = "货柜容量更新成功"
             }

             this.editInfoUserId = this.userId
             this.editInfoType = type
             this.$refs.dialog.show()
         },
         updateInfo(type, info) {
             if (type == "bossName") {
                 this.userName = info
             } else if (type == "bossPhone") {
                 this.phone = info
             } else if (type == "companyName") {
                 this.companyName = info
             } else if (type == "shopName") {
                 this.shopName = info
             } else if (type == "wxMchId") {
                 this.wxMchId = info
             } else if (type == "wxPlanId") {
                 this.wxPlanId = info
             } else if (type == "commodityLimit") {
                 this.commodityLimit = info
             } else if (type == "machineCommodityLimit") {
                 this.machineCommodityLimit = info
             }
         },
         deleteUser() {
             const modal = Modal.confirm();
             var that = this
             modal.update({
                 title: "删除商户",
                 content: '删除商户非常非常危险，如果不确定风险，请咨询研发的同学，评估风险。确定要删除此商户吗?',
                 centered: true,
                 okText: "确认",
                 cancelText: "取消",
                 onOk() {
                     const url = `${process.env.VUE_APP_API_SERVER}/business/${that.userId}`;
                     var accessToken = localStorage.getItem('accessToken')

                     fetch(url, {
                         method: 'DELETE',
                         headers: new Headers({
                             'Content-Type': 'application/json',
                             'Access-Token': accessToken
                         })
                     }
                     ).then(res => res.json()
                     ).catch(error => {
                         message.error("删除商户失败，错误码: " + error)
                     }).then(response => {
                         console.log(response)

                         that.$router.go(-1)
                     })
                 }
             })
         }
     },
 }
</script>

<style scoped>
 .info-area {
     width: 100%;
     height: 100%;
     padding-top: 80px;
     padding-left: 80px;
     padding-right: 80px;

     background-color: #FFF;
 }

 .title {
     font-size: 24px;
     margin-left: 30px;
     margin-bottom: 20px;
     text-align: start;
 }

 .info-line {
     display: flex;
     flex-direction: column;
     justify-content: flex-start;
     width: 100%;
     border-right: 1px solid #EEE;
     padding-left: 30px;
 }

 .info-line:last-child {
     border-right: none;
 }

 .info-label {
     font-size: 18px;
     color: #333;
     width: 160px;
     text-align: start;
     margin-bottom: 10px;
     user-select: none;
 }

 .info-content {
     font-size: 16px;
     color: #999;
     text-align: start;
     height: 24px;
 }

 .info-paragraph {
     display: flex;
     flex-direction: row;
     align-items: center;
     justify-content: space-around;
     padding-top: 30px;
     padding-bottom: 30px;
     border-bottom: 1px solid #EFEFEF;
 }

 .content-area {
     display: flex;
     flex-direction: row;
     align-items: center;
 }

 .edit-button {
     margin-left: 5px;
     margin-bottom: 2px;
     font-size: 16px;
     color: #333;
     cursor: pointer;
 }

 .edit-button:hover {
     color: #587FE0;
 }

 .delete-button {
     position: absolute;
     bottom: 15px;
 }
</style>
